import React from 'react';
import Seperator from '../../../../seperator';
export default function CardBottomLowestValidThruRight({
  cardValidMonth,
  cardValidYear
}) {
  const yearFormat = cardValidYear.toString().slice(2, 4);
  const monthFormat = cardValidMonth < 10 ? `0${cardValidMonth}` : cardValidMonth;
  return /*#__PURE__*/React.createElement("div", {
    className: "valid-thru-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "thru"
  }, /*#__PURE__*/React.createElement(Seperator, {
    classes: "seperator-owner"
  }, monthFormat), /*#__PURE__*/React.createElement(Seperator, {
    classes: "seperator-owner"
  }, "/"), /*#__PURE__*/React.createElement(Seperator, {
    classes: "seperator-owner"
  }, yearFormat)));
}